import { styled, Theme } from '@material-ui/core';

export const NotificationsIconMenuContainer = styled('div')<Theme>(({ theme }) => ({
  lineHeight: 'normal',
}));
